import Axios from 'api/axios'
import type { PisDeposit, PisDepositEvent } from '../types'

const basePath = (customerId: string) => `/bo/v1/customers/${customerId}/pis-deposits`

export const listPisDeposits = (customerId: string): Promise<PisDeposit[]> => Axios.get(basePath(customerId)).then(({ data }) => data)

export const listPisDepositEvents = (customerId: string, depositId: string): Promise<PisDepositEvent[]> =>
  Axios.get(`${basePath(customerId)}/${depositId}/events`).then(({ data }) => data)

export const inspectPisDeposit = (customerId: string, depositId: string): Promise<PisDeposit> =>
  Axios.get(`${basePath(customerId)}/${depositId}`).then(({ data }) => data)
